/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import React, { forwardRef } from 'react';
import { KeyCode, LinkButton as LinkButtonKit } from '@veeam/components';

import type { FC } from 'react';

type LinkButtonProps = Parameters<typeof LinkButtonKit>[0];

export const LinkButton: FC<LinkButtonProps> = forwardRef((props, ref) => {
    const { onClick, onKeyDown } = props;

    return (
        <LinkButtonKit
            {...props}
            onKeyDown={(event: React.KeyboardEvent) => {
                if (event.key === KeyCode[KeyCode.Enter]) {
                    onClick && onClick(event as any);
                }
                onKeyDown && onKeyDown(event);
            }}
            ref={ref}
        />
    );
});
